import ConversationSortOrder from 'owa-service/lib/contract/ConversationSortOrder';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function getConversationSortOrderFromSettings(): ConversationSortOrder {
    const userConfiguration = getUserConfiguration();
    const sortOrderFromOptions = userConfiguration.UserOptions.ConversationSortOrderReact;
    let conversationSortOrder: ConversationSortOrder;
    if (sortOrderFromOptions !== undefined && typeof sortOrderFromOptions === 'string') {
        // Convert string to enum
        conversationSortOrder = sortOrderFromOptions;
    } else {
        conversationSortOrder = sortOrderFromOptions as ConversationSortOrder;
    }
    return conversationSortOrder;
}
